import { useSeekaConverge } from '@seeka-labs/converge-react';
import { navigate, PageProps } from 'gatsby';
import React, { useEffect } from 'react';

type QrCodeContext = {
  qr: {
    key: string
    type: 'product'
  }
}

export default function QrRedirectPageTemplate(props: PageProps<unknown, QrCodeContext>) {
  const seeka = useSeekaConverge();

  useEffect(() => {
    seeka.track.custom('QrCodeScan', {
      contentName: props.pageContext.qr?.key,
      contentId: props.pageContext.qr?.key
    })

    navigate('/getting-started-with-methylene-blue' as any);
  }, [])


  return <></>
}